import React from 'react';
import LeadCardNormal from './LeadCardNormal';
import LeadCardCollapsed from './LeadCardCollapsed';

// Seletor entre os 2 layouts de card, cada um completo e independente
// (LeadCardNormal.js / LeadCardCollapsed.js) — ver Leads.List.js para a prop `detailed`.
const LeadsCard = ({ detailed = true, ...props }) =>
  detailed ? <LeadCardNormal {...props} /> : <LeadCardCollapsed {...props} />;

export default LeadsCard;
